export default __webpack_public_path__ + "static/media/mongodb_programming_icon.80786bce.png";